module.exports = __webpack_public_path__ + "img/message.42556d01.svg";